import React, {Component} from 'react';
import "../style/showcase.scss"
import SliderComponent from "../../Slider/components/SliderComponent";
import isMobile from 'is-mobile';

class ShowcaseComponent extends Component {

    render() {
        const {images, imageOrientation} = this.props;

          if(images === undefined || images.length === 0) { return (<div>&nbsp;</div>)}

        return (
            <div id="showcase">

                {
                    images.length > 1 ? (
                        <SliderComponent
                            dots={true}
                            infinite={false}
                            speed="500"
                            slideScroll={1}
                            slidetoshow={1}
                            slidesPerRow={1}
                            isMobile={isMobile()}
                            activeSlide={true}
                            arrow={true}>
                            {images.map((image, i) => {
                                return (
                                    <div key={i}>
                                        <img src={`${image.featured_image}`} alt=""/>
                                    </div>
                                )
                            })}
                        </SliderComponent>
                    ) : (
                        <div>
                            {
                                !images[0].featured_image ?
                                    imageOrientation === "portrait" ? (
                                        <img src={`${images[0].portrait_image }`} alt="1"/>
                                    ) : (
                                        <img src={`${images[0].landscape_image }`} alt="2"/>
                                    ) : (
                                        <img src={`${images[0].featured_image }`} alt="1"/>
                                    )}

                        </div>
                    )}

            </div>
        );
    }
}

export default ShowcaseComponent;
